import { DataSource, DataSourceMode, TableRow } from "@mcleod/components";
import { AssignedMovementOverview, MovementOfferTabs } from "@mcleod/dispatch";
import { BrokerageMovementTableType } from "./BrokerageMovementTableType";
import { AutogenLayoutBrokerageMovementsGridExpansion } from "./autogen/AutogenLayoutBrokerageMovementsGridExpansion";

export class BrokerageMovementsGridExpansion extends AutogenLayoutBrokerageMovementsGridExpansion {
    private movementID: string;
    private orderID: string;
    private brokeragePlanningSource: DataSource;
    private status: string;
    private row: TableRow;
    private type: BrokerageMovementTableType;

    public initialize(row: TableRow, movementID: string, orderID: string, status: string, dataSource: DataSource, type: BrokerageMovementTableType): void {
        this.movementID = movementID;
        this.orderID = orderID;
        this.status = status;
        this.brokeragePlanningSource = dataSource;
        this.row = row;
        this.type = type;

        const isAvailable = this.type === BrokerageMovementTableType.AVAILABLE;
        const movementOfferLayout = this.status === "A" ? isAvailable ? this.layoutMovementOfferTabs : this.layoutMovementOffers : null;
        if (movementOfferLayout != null) {
            if (movementOfferLayout instanceof MovementOfferTabs) {
                movementOfferLayout.stopCountText = this.row.data.get("stops_pick_drop");
                movementOfferLayout.initialize(this.orderID, this.movementID, row.data);
            } else {
                movementOfferLayout.initialize(this.orderID, null, this.movementID);
            }
            this.layoutMovementOfferTabs.visible = isAvailable;
            this.layoutMovementOffers.visible = !isAvailable;
            this.layoutAssignedMovementOverview.visible = false;
            this.buttonSave.visible = false;
        } else if (this.movementID != null) {
            this.buttonSave.visible = true;
            this.layoutMovementOffers.visible = false;
            this.layoutMovementOfferTabs.visible = false;
            const overview: AssignedMovementOverview = this.layoutAssignedMovementOverview as AssignedMovementOverview;
            overview.addLayoutLoadListener(event => {
                this.buttonSave.dataSource = this.sourceMovement;
                this.buttonSave.enabled = false;
            })
            overview.visible = true;
            overview.panelContent.borderWidth = 0;
            overview.tabsetCarrierDriver.borderWidth = 0;
            overview.tabsetCarrierDriver.addCenterTool(this.buttonSave);
            this.sourceMovement?.search({ id: this.movementID }).then(result => {
                this.sourceMovement.mode = DataSourceMode.UPDATE;
                overview.movementActions.doAfterAction = () => { this.brokeragePlanningSource.search(this.brokeragePlanningSource.lastSearch) }
            });
        }

        this.buttonSave.addClickListener(() => {
            this.buttonSave.enabled = false;
            this.buttonSave.busy = true;
            this.sourceMovement?.post().then(() => {
                this.buttonSave.busy = false;
            }).catch(() => {
                this.buttonSave.busy = false;
                this.buttonSave.enabled = true;
            });
        })
    }
}
